/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import BossDialog from "../../components/BossDialog";
import { Form, FormElement } from "@progress/kendo-react-form";
import * as API from "../../framework/API/api"
import { CONTENT_CUSTOM_ENUM, ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import { utility } from "../../framework/utility/utilityProvider";
import MediaSubCategoryTypeEditForm from "./MediaSubCategoryTypeEditForm";
import ToastNotification from "../../components/ToastNotification";


export const ContentEditForm = (props) => {

  const [mediaCategoryType, setMediaCategoryType] = useState([]);
  const lang = useTranslation();

  const blankDataItem = {
    ...props.item,
    SID: props.item.SID ?? 0,
    MediaCategoryType: props.item.MediaCategoryType ?? {},
    Description: props.item.copy ? 'copy of ' + props.item.Description : props.item.Description ?? '',
    NextNumber: props.item.NextNumber ?? 1,
    Prefix: props.item.Prefix ?? '',
    Length: props.item.Length ?? 5,
    Archive: props.item.Archive ?? false,
    MediaSubCategoryType: props?.item?.MediaSubCategoryType ?? [],
    Custom : props.item.Custom ? { _id : props.item.Custom, Description : utility.getKeyByValue(CONTENT_CUSTOM_ENUM, props.item.Custom) } : {},
    Year: props.item.Year ?? ''
  }

  const [dataItem, setDataItem] = useState(blankDataItem);
  const [mediaSubCategoryType, setMediaSubCategoryType] = useState([]);
  const [showMediaSubCategoryType, setShowMediaSubCategoryType] = useState(false);


  useEffect(() => {
    loadcombo();
  }, [])


  const loadcombo = async () => {

    let mediaSubCategoryTypeRes = await API.getDataLookup(ENTITYNAME.MediaSubCategoryType, { sort: { SID: 1 } });
    setMediaSubCategoryType(mediaSubCategoryTypeRes.data);

    let mediaCategoryTypeRes = await API.getDataLookup(ENTITYNAME.MediaCategoryType, { sort: { Description: 1 } });
    let filtered = mediaCategoryTypeRes.data
    if (props.filterMediaCategory) {
      filtered = mediaCategoryTypeRes.data.filter((x) => x.MediaCategorySID == props.filterMediaCategory)
      setDataItem({
        ...blankDataItem,
        MediaCategoryType: filtered?.length > 0 ? filtered[0] : {},
        MediaSubCategoryType: {},
      })
    }
    filtered = [ { _id : "All", SID : 999999, Description : "All", MediaCategorySID : 0 }, ...filtered ]
    setMediaCategoryType(filtered);
  }

  //function to check the validation in form
  function validationCheck() {

    if (dataItem.Description == undefined || dataItem.Description == "") {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_description_error_message });
      return false;
    }
    if (dataItem.MediaCategoryType == undefined || Object.keys(dataItem.MediaCategoryType).length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_media_category_type_error_message });
      return false;
    }
    if (dataItem.Prefix == undefined || dataItem.Prefix == "") {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_prefix_error_message });
      return false;
    }
    if (dataItem.NextNumber == undefined || dataItem.NextNumber == "") {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_next_number_error_message });
      return false;
    }
    if (dataItem.NextNumber <= 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.next_number_can_not_be_negative_or_zero_error_meessage });
      return false;
    }
    if (!dataItem.Length || dataItem.Length <= 0 || dataItem.Length > 10) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.number_length_should_be_between_1_to_10_error_message });
      return false;
    }
    return true;
  }

  const handleSubmit = async (e) => {

    if (validationCheck()) {
      const saveData = {
        _id: dataItem._id,
        SID: dataItem.SID ?? 0,
        MediaCategoryType: {
          _id: dataItem.MediaCategoryType._id,
          SID: dataItem.MediaCategoryType.SID,
          Description: dataItem.MediaCategoryType.Description,
          MediaCategorySID: dataItem.MediaCategoryType.MediaCategorySID
        },
        Description: dataItem.Description,
        Prefix: dataItem.Prefix,
        NextNumber: parseInt(dataItem.NextNumber),
        Length: parseInt(dataItem.Length),
        Archive: dataItem.Archive ?? false,
        MediaSubCategoryType: dataItem?.MediaSubCategoryType && Object.keys(dataItem?.MediaSubCategoryType)?.length > 0 ? {
          _id: dataItem?.MediaSubCategoryType?._id,
          SID: dataItem?.MediaSubCategoryType?.SID,
          Description: dataItem?.MediaSubCategoryType?.Description,
          MediaCategorySID: dataItem?.MediaSubCategoryType?.MediaCategorySID
        } : {},
        Custom : dataItem?.Custom?._id,
        Year: dataItem?.Year,
        checkDuplicate: true,
        query: [["Prefix", "=", dataItem.Prefix]],
      }
      console.log(saveData);

      let res = await API.saveData(ENTITYNAME.Content, saveData);
      if (res.success) {
        let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.CONTENT, data: res.data, message: res.message };
        API.SaveLogs(logData);
        utility.deleteLocalStorageItem(ENTITYNAME.Content);
        props.cancelEdit();
        props.refresh();
      } else if (res.code == 413) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.entry_already_exists_in_system_for_same_prefix_and_suffix_error_message });
      }
      else {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
      }
    }
  }

  const onChangeForm = (e) => {

    if (e.target.name == "Archive") {
      setDataItem({ ...dataItem, Archive: !dataItem.Archive });
    } else {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }

  }

  return (
    <BossDialog
      title={props.item.SID > 0 ? props.item.Description : "Create Content"}
      onClose={props.cancelEdit}
      width={"770px"}
    >
      <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
      <Form
        initialValues={dataItem}
        render={(formRenderProps) => (
          <FormElement>
            <div className="row mt-2">
              <div className="col-12">
                <div className="row">
                  <div className="col-6">
                    <label>{lang.description_label} *</label>
                    <input
                      name={"Description"}
                      type="text"
                      className="form-control form-control-sm"
                      onChange={onChangeForm}
                      value={dataItem.Description}
                    />
                  </div>
                  <div className="col-6">
                    <label>{lang.media_category_type_label} *</label>
                    <DropDownList
                      style={{ backgroundColor: 'white' }}
                      name={"MediaCategoryType"}
                      dataItemKey="_id"
                      textField={"Description"}
                      value={dataItem.MediaCategoryType}
                      data={mediaCategoryType}
                      onChange={onChangeForm}
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-6">
                    <label>{lang.prefix_label} *</label>
                    <input
                      name={"Prefix"}
                      type="text"
                      className="form-control form-control-sm"
                      value={dataItem.Prefix}
                      onChange={onChangeForm}
                    />
                  </div>
                  <div className="col-6" >
                    <label>{lang.next_number_label} *</label>
                    <input
                      name="NextNumber"
                      className="form-control form-control-sm"
                      value={dataItem.NextNumber}
                      type="number"
                      onChange={onChangeForm}
                      min={0}
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-6" >
                    <label>{lang.number_length_label} *</label>
                    <input
                      name="Length"
                      className="form-control form-control-sm"
                      value={dataItem.Length}
                      type="number"
                      onChange={onChangeForm}
                      min={0}
                    />
                  </div>
                  <div className="form-group col-6">
                    <label htmlFor="">{lang.type_label}</label>
                    <div style={{ display: 'flex' }}>
                      <DropDownList
                        style={{ backgroundColor: 'white' }}
                        data={mediaSubCategoryType}
                        name="MediaSubCategoryType"
                        textField="Description"
                        dataItemKey="_id"
                        value={dataItem.MediaSubCategoryType}
                        onChange={onChangeForm}
                      />
                      <button type="button" title={lang.create_media_subcategory_type_button_tooltip} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary "
                        style={{ height: "30px", margin: '0px 0px 0px 5px' }} onClick={() => setShowMediaSubCategoryType(true)}><i className="fa-solid fa-plus fa-xs"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <label>{lang.content_custom_label}</label>
                    <DropDownList
                      style={{ backgroundColor: 'white' }}
                      name={"Custom"}
                      dataItemKey="_id"
                      textField={"Description"}
                      value={dataItem.Custom}
                      data={Object.keys(CONTENT_CUSTOM_ENUM).map(k => { return { _id: CONTENT_CUSTOM_ENUM[k], Description: utility.getKeyByValue(CONTENT_CUSTOM_ENUM, CONTENT_CUSTOM_ENUM[k]) } })}
                      onChange={onChangeForm}
                    />
                  </div>
                  <div className="col-6" >
                    <label>{lang.year_label}</label>
                    <input
                      name="Year"
                      className="form-control form-control-sm"
                      value={dataItem.Year}
                      type="number"
                      onChange={onChangeForm}
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-2" >
                    <input type={"checkbox"} name={"Archive"}
                      onChange={(e) => onChangeForm(e)}
                      value={dataItem.Archive}
                      checked={dataItem.Archive} />
                    <label className="ml-1">{lang.archive}</label>
                  </div>
                </div>
              </div>
            </div>
          </FormElement>
        )}
      />
      {showMediaSubCategoryType && <MediaSubCategoryTypeEditForm item={{ SID: 0 }} cancelEdit={() => setShowMediaSubCategoryType(false)} refresh={() => loadcombo()} />}
    </BossDialog>)
};